/**
 * Receipt scope for checkout session / post-pay surfaces (B-23, P28-G36).
 */
import { createContext, useContext, useMemo, type ReactNode } from 'react';

export interface ReceiptScope {
  readonly paymentId: string;
  readonly checkoutSessionPublicId?: string | null;
  readonly returnPathWithQuery?: string;
}

const ReceiptContext = createContext<ReceiptScope | null>(null);

export interface ReceiptProviderProps {
  readonly scope: ReceiptScope;
  readonly children: ReactNode;
}

export function ReceiptProvider({ scope, children }: ReceiptProviderProps): JSX.Element {
  const value = useMemo(() => scope, [scope]);
  return <ReceiptContext.Provider value={value}>{children}</ReceiptContext.Provider>;
}

export function useReceiptScope(): ReceiptScope | null {
  return useContext(ReceiptContext);
}

export function useRequiredReceiptScope(): ReceiptScope {
  const scope = useReceiptScope();
  if (scope === null) {
    throw new Error('ReceiptProvider is required for this surface');
  }
  return scope;
}
